<template>
  <div class="goods" @click="onClick">
    <div class="image-wrap">
        <img :src="$getCdnUrl(info.image)" alt=""/>
    </div>
    <div class="tlt">
        <xl-tooltip :content="info.productConfigName" placement="top">
            {{ info.productConfigName }}
        </xl-tooltip>
    </div>

    <div class="desc time-wrap">
        <span class="tip">
            {{$t('design.case.deliveryCycle') || '交付周期'}}
        </span>
        <span class="time">{{ $timeUnit( VueCookieNext.getCookie('lang'), info.deliveryUnit, info.deliveryDay ) }}</span>
    </div>
    <div class="desc">
        <span class="tip">{{ $t('design.case.unit') || '单位'}}</span>
        <span class="time">{{unitMap[info.chargeUnit]}}</span>
    </div>
    <div class="desc" :style="{ opacity: info.points ? 1 : 0 }">
        <span class="tip">{{ $t('design.goods.pointName') || "积分" }}</span>
        <div class="price-wrap">
            <!-- <span class="price" v-if="info.points">{{$t('design.point.pointNum', { point: info.points })}}</span> -->
            <span class="price">{{info.points}}<span class="priceType">{{$t('design.point.pointNumText')}}</span></span>
        </div>
    </div>
    <div class="hr">
        <span class="line"></span>
        <span class="or" v-if="info.points">{{ $t('design.goods.or') || 'or' }}</span>
        <span class="line-or" v-else><span class="line"></span></span>
        <span class="line"></span>
    </div>
    <div class="desc mb12">
        <span class="tip">{{$t('design.case.price') || '费用'}}</span>
        <div class="price-wrap">
            <span class="price">{{formatPrice(info.price)}}</span>
            <span class="priceType">{{info.currency}}</span>
            <span v-if="info.discountPrice" class="price discount_price">{{formatPrice(info.discountPrice)}}</span>
            <span v-if="info.discountPrice" class="priceType discount">{{info.currency}}</span>
        </div>
    </div>
    <!-- <div class="desc">
        <span class="tip">{{$t('design.case.price') || '费用'}}/{{unitMap[info.chargeUnit]}}</span>
        <div class="price-wrap">
            <span class="price">{{formatPrice(info.price)}}</span>
            <span class="priceType">{{info.currency}}</span>
            <span v-if="info.discountPrice" class="price discount_price">{{formatPrice(info.discountPrice)}}</span>
            <span v-if="info.discountPrice" class="priceType discount">{{info.currency}}</span>
        </div>
    </div>
    <div class="desc time-wrap">
        <span class="tip">
            {{$t('design.case.deliveryCycle') || '交付周期'}}
        </span>
        <span class="time">{{ $timeUnit( VueCookieNext.getCookie('lang'), info.deliveryUnit, info.deliveryDay ) }}</span>
    </div> -->
    <div class="u-labels">
        <div class="u-discount" v-if="info.discountPrice">{{ $t('design.order.discountPrice') || '折扣价'}}</div>
        <div v-if="info.aiProduct && info.aiTips" class="u-ai"><span class="text">{{ info.aiTips }}</span></div>
    </div>
  </div>
</template>

<script setup>
import { XlTooltip } from "@shining3d/ui-components";
import { ref, defineEmits } from "vue";
import { useLang } from "@shining3d/common-module/utils/lang.js";
const { $t } = useLang("@shining3d/xl-design-order");
import image from '../../../assets/image/image14.png';
import { timeMap, unitMap } from '../const';
import { $getCdnUrl, formatPrice, $timeUnit } from '../../../utils/common'
import { VueCookieNext } from 'vue-cookie-next';

const emits = defineEmits(['click']);

const props = defineProps({
    info: {
        type: Object,
        default: {
            image: {},
        }
    }
});

const onClick = () => {
    emits('click', props.info);
};

</script>

<style lang="scss" scoped>
.goods {
    margin-right: 12px;
    margin-bottom: 12px;
    width: 280px;
    height: 369px;
    border: 1px solid #E0E4EA;
    border-radius: 6px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    position: relative;
    font-family: 'Alibaba PuHuiTi 2.0';
    background: #fff;
    overflow: hidden;
    .image-wrap {
        width: 100%;
        text-align: center;
        height: 186px;
        line-height: 186px;
        img{
            width: 100%;
            height: 186px;
        }
    }
    
    .tlt {
        margin-top: 12px;
        font-weight: 500;
        padding: 0 12px;
        font-size: 14px;
        line-height: 22px;
        color: #2C364E;
        margin-bottom: 8px;
        // height: 44px;
        // max-height: 44px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis
    }

    .desc {
        padding: 0 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 22px;
        margin-bottom: 4px;
    }
    .mb12{
        margin-bottom: 12px !important;
    }
    .tip {
        font-size: 14px;
        color: #A5ACBE; 
    } 
    .time {
        color: #42526E;
        font-size: 14px;
    }
    .price {
        font-family: 'Alibaba PuHuiTi 2.0';
        font-weight: 500;
        font-size: 18px;
        color: #FF6914;
        // margin-right: 4px;
    }
    .priceType {
        font-family: 'Alibaba PuHuiTi 2.0';
        font-weight: 500;
        color: #FF6914;
        font-size: 13px;
    }
    .discount,
    .discount_price {
        font-size: 13px;
        color: #A5ACBE;
        text-decoration: line-through;
    }
    .discount_price {
        padding-left: 4px;
    }
    .u-labels {
        position: absolute;
        top: 4px;
        left: 4px;
        display: flex;
        align-items: center;
    }
    .u-discount {
        padding: 0 11px;
        background-color: rgba(255, 105, 20, 0.19);
        color: rgba(255, 105, 20, 1);
        border-radius: 4px;
        backdrop-filter: blur(4px);
        height: 22px;
        text-align: center;
        font-size: 12px;
        font-weight: 600;
        line-height: 22px;
        font-family: $font-family65;
        margin-right: 8px;
    }
    .u-ai {
        font-size: 12px;
        font-weight: 600;
        height: 22px;
        line-height: 22px;
        text-align: center;
        font-family: $font-family65;
        padding: 0 10px;
        border-radius: 4px;
        background: linear-gradient(102.09deg, rgba(20, 185, 255, 0.29) 14.17%, rgba(1, 55, 249, 0.29) 89.71%);
        // backdrop-filter: blur(3px);
        flex: 1;
        overflow: hidden;
        backdrop-filter: blur(11px);
        .text {
            background-image: linear-gradient(102.09deg, #21BCFF 14.17%, #0137F9 89.71%);
            background-clip: text; /*必需加前缀 -webkit- 才支持这个text值 */
            -webkit-text-fill-color: transparent; /*text-fill-color会覆盖color所定义的字体颜色： */
        }
    }
    .hr {
        display: flex;
        align-items: center;
        padding: 0 12px;
        box-sizing: border-box;
        margin-bottom: 4px;

        .line {
            flex: 1;
            border-top: 1px dashed #E0E4EA;
        }
        .or {
           min-width: 28px;
           height: 18px;
           border: 1px solid #A5ACBE;
           color: #737E99;
           border-radius: 4px;
           display: flex;
           justify-content: center;
           align-items: center;
           margin: 0 6px;
           font-size: 12px;
           box-sizing: border-box;
        }
        .line-or {
            height: 18px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
        }
    }

    &:hover {
        border: 1px solid #5587FF;
    }

    &:nth-child(3n) {
        margin-right: 0 !important;
    }
}
.goods-active {
    border: 1px solid #5587FF;
    box-shadow: 0px 2.04px 0px 0px #5587FF;
}

@media screen and (min-width: 1614px){
    .goods {
        &:nth-child(3n) {
            margin-right: 12px !important;
        }
        &:nth-child(4n) {
            margin-right: 0px !important;
        }
    }
}
</style>